
const headerSearchButton = document.querySelector(".js-header-btn-search");
const headerSearchInput = document.querySelector(".js-header-search-input");
const headerSearchResultsPageUrl = headerSearchButton?.getAttribute("data-resultsUrl");


function performSearch() {

	const searchText = headerSearchInput.value.trim();

	if (searchText) {
		const searchResultsPageLocation = headerSearchResultsPageUrl + "?term=" + encodeURIComponent(searchText);
		window.location = searchResultsPageLocation;
	}

}

function regsiterSearchListeners() {

	if (headerSearchButton) {

		headerSearchButton.addEventListener("click", event => {
			event.preventDefault;
			performSearch();
		})

		headerSearchInput.addEventListener("keyup", event => {

			if (event.key == "Enter" || event.key == 13) {
				event.preventDefault;
				performSearch();
			}

		})
	}

}


function initializeHeaderSearch() {
	regsiterSearchListeners();

};

export {
	initializeHeaderSearch
}
